import { View } from 'react-native';
import Stack from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import { getSpacing } from '../../../utils/spacing';
import { maxFormWidth } from '../../v2BaseComponents/Form/CenteredFormRow';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import React from 'react';

const MaybeStackedImageField: React.FC<{
    children: React.ReactNode;
    helpTextMain: string;
    subHelpText: string;
}> = ({ children, helpTextMain, subHelpText }) => {
    const isMobile = useIsMobileLayout();

    const alignText = isMobile ? 'center' : 'left';

    const helpTextContent = (
        <Stack
            vertical
            space={getSpacing(isMobile ? 1 : 4)}
            style={{ marginBottom: isMobile ? 16 : undefined }}
            align={isMobile ? 'center' : 'flex-start'}
        >
            <Text variant="bold-body-1" style={{ maxWidth: 320 }} alignText={alignText}>
                {helpTextMain}
            </Text>
            <Text variant="caption-2" color="Gray-Text" alignText={alignText} style={{ maxWidth: 320 }}>
                {subHelpText}
            </Text>
        </Stack>
    );

    if (isMobile) {
        return (
            <Stack horizontal justify="center" fullWidth>
                <Stack vertical space={getSpacing(2)} justify="center" align="center">
                    <View>{children}</View>
                    {helpTextContent}
                </Stack>
            </Stack>
        );
    } else {
        return (
            <Stack horizontal fullWidth justify="center">
                <Stack
                    horizontal
                    justify="flex-start"
                    style={{ maxWidth: maxFormWidth, width: '100%' }}
                    testID="max-width-image-container"
                >
                    <Stack horizontal space={getSpacing(8)} align="center" justify="flex-start">
                        <View>{children}</View>
                        <View style={{ marginTop: 20 }}>{helpTextContent}</View>
                    </Stack>
                </Stack>
            </Stack>
        );
    }
};

export default React.memo(MaybeStackedImageField);
